import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IGetDocumentosUseCase } from "../../../presentation/useCases/read/get_documentos_use_case";
import { Documento } from "../../models/documento";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * GetDocumentoUseCase
 */

export class GetDocumentosUseCase extends BasePaginatedUseCase<Documento> implements IGetDocumentosUseCase {
  constructor(
    private readonly repository: IRhRepository,
  ) {
    super();
  }

  async getDocumentos(
    idFuncionario: number,
    page: number,
    pageSize: number,
  ): Promise<void> {
    const response = await this.repository.getDocumentos(
      idFuncionario,
      page,
      pageSize,
    );

    this._items = response.items;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
  }
}